import { Swiper } from './swiper-DSEIACnL.js';
import { N as Navigation } from './navigation-DWrRZ7mI.js';
import { P as Pagination } from './pagination-BiRS_VrL.js';
import { A as A11y } from './a11y-CNmE74mL.js';
import { G as Grid } from './grid-BA0Rwurj.js';
import './utils-CPPFXbqB.js';
import './create-element-if-not-defined-BweCirD8.js';

class TrustpilotReviews extends HTMLElement {
  connectedCallback() {
    new Swiper(this.querySelector('.swiper'), {
      modules: [A11y, Grid, Navigation, Pagination],
      spaceBetween: 16,
      slidesPerView: 1.24,
      navigation: {
        prevEl: this.querySelector('.swiper-button-prev'),
        nextEl: this.querySelector('.swiper-button-next'),
      },
      pagination: {
        el: this.querySelector('.swiper-pagination'),
      },
      breakpoints: {
        640: {
          slidesPerView: 2.3,
        },
        768: {
          slidesPerView: 2,
          slidesPerGroup: 4,
          grid: {
            rows: 2,
            fill: 'row',
          },
        },
      },
    });
  }
}

customElements.define('trustpilot-reviews', TrustpilotReviews);
